import { EstimateRow } from "features/subscriptions/components/ManageSubscription/EstimateRow";
import useEstimateRenewal from "features/subscriptions/datahooks/useEstimateRenewal";
import {
  formatPrice,
  formatPricingPeriodInfo,
  parseEstimate,
} from "features/subscriptions/utils";

import { Tag } from "common/components/ui/Tag";
import type { PricingPeriodInfo, SubscriptionType } from "common/types";

export function CurrentSubscriptionEstimate({
  subscriptionType,
  quantity,
  subscriptionId,
  pricingPeriodInfo,
}: {
  subscriptionType: SubscriptionType;
  quantity: number;
  subscriptionId?: string;
  pricingPeriodInfo: PricingPeriodInfo;
}) {
  const { estimateRenewal, isLoadingEstimateRenewal } = useEstimateRenewal(
    subscriptionType === "agency" ? undefined : subscriptionId,
  );

  let previousPriceComponent: JSX.Element;
  let priceValue: number;

  if (estimateRenewal) {
    const { amountDue, coupon, creditsApplied } = parseEstimate(
      estimateRenewal.invoice_estimate || estimateRenewal.next_invoice_estimate,
    );

    priceValue = amountDue + creditsApplied;

    if (coupon) {
      previousPriceComponent = (
        <span className="text-md-medium text-black-500 line-through">
          {formatPrice(amountDue + coupon.amount)}
        </span>
      );
    }
  }

  return (
    <div className="relative mt-3.5">
      <Tag size="sm" variant="info" className="absolute -mt-3.5 ml-1.5">
        Current plan
      </Tag>
      {/* Current plan */}
      <div className="flex flex-col gap-y-2.5 rounded-2xl border border-black-200 bg-white py-2.5">
        <EstimateRow
          label={`No. of ${subscriptionType === "rental" ? "avatars" : "seats"}`}
          tooltipText={
            subscriptionType === "rental"
              ? "The number of Avatars included in your subscription. Avatars come with their own seats, they do not use seats from other sources"
              : "The number of seats included in your subscription"
          }
          valueComponent={
            <span className="text-md-bold text-black-500">{quantity}</span>
          }
          isLoading={false}
        />
        <EstimateRow
          label={subscriptionType === "rental" ? "Price" : "Plan price"}
          tooltipText="The recurring price for your subscription"
          valueComponent={
            <>
              {previousPriceComponent}
              <span className="text-md-bold text-black-500">
                {priceValue === undefined
                  ? "-"
                  : `${formatPrice(priceValue)} / ${formatPricingPeriodInfo(pricingPeriodInfo)}`}
              </span>
            </>
          }
          isLoading={isLoadingEstimateRenewal}
        />
      </div>
    </div>
  );
}
